<template>
  <div class="slide bullet-list" :style="rootStyle">
    <div class="content">
      <h1 v-if="data.heading" class="heading" :style="headingStyle">{{ data.heading }}</h1>
      <ul class="bullets">
        <li
          v-for="(bullet, i) in data.bullets || []"
          :key="i"
          class="bullet"
          :class="{ 'is-visible': i < revealedCount }"
          :style="bulletStyle"
        >
          <span class="marker" :style="{ background: colors.accent || '#60A5FA' }"></span>
          <span class="text">{{ typeof bullet === 'string' ? bullet : bullet.text }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletList',
  props: {
    data: { type: Object, required: true },
    config: { type: Object, default: () => ({}) },
    progress: { type: Number, default: 1 }
  },
  computed: {
    colors() {
      return this.config.color_scheme || {}
    },
    font() {
      return this.config.font || {}
    },
    rootStyle() {
      return {
        background: this.colors.background || '#0F172A',
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.body || 'Inter, system-ui, sans-serif'
      }
    },
    headingStyle() {
      return {
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.heading || 'Inter, system-ui, sans-serif'
      }
    },
    bulletStyle() {
      return {
        color: this.colors.text || '#F8FAFC'
      }
    },
    revealedCount() {
      const n = (this.data.bullets || []).length
      if (!n) return 0
      return Math.max(1, Math.ceil(this.progress * n))
    }
  }
}
</script>

<style scoped>
.slide {
  width: 1920px;
  height: 1080px;
  display: flex;
  align-items: center;
  padding: 120px;
  box-sizing: border-box;
}
.content {
  width: 100%;
}
.heading {
  font-size: 88px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 64px;
}
.bullets {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bullet {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  font-size: 44px;
  line-height: 1.4;
  padding: 18px 0;
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 450ms ease, transform 450ms ease;
}
.bullet.is-visible {
  opacity: 1;
  transform: translateY(0);
}
.marker {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-top: 24px;
}
.text {
  flex: 1;
}
</style>
